import { useEffect, useState } from 'react'
import { firebaseRtdb } from '@/lib/firebase'
import { onValue, ref, get, DataSnapshot } from 'firebase/database'

interface UserStatus {
  state: 'online' | 'offline'
  updatedAt?: number
}

export function useOnlineUserCount() {
  const [onlineCount, setOnlineCount] = useState(0)

  useEffect(() => {
    const userStatusRef = ref(firebaseRtdb, '/online-status')

    const updateOnlineCount = (snapshot: DataSnapshot) => {
      const data = snapshot.val() || {}
      const count = Object.values(data).filter((user): user is UserStatus => {
        return Boolean(
          user &&
            typeof user === 'object' &&
            'state' in user &&
            (user as UserStatus).state === 'online',
        )
      }).length
      setOnlineCount(count)
    }

    // ดึงข้อมูลครั้งแรกทันทีเมื่อ hook ถูกเรียกใช้
    get(userStatusRef)
      .then(updateOnlineCount)
      .catch((error) => {
        console.error('Error fetching initial online user count:', error)
      })

    // ตั้ง listener เพื่อฟังการเปลี่ยนแปลงต่อไป
    const unsubscribe = onValue(userStatusRef, updateOnlineCount)

    return () => unsubscribe()
  }, [])

  return onlineCount
}
